import { useCallback, useMemo } from "react";
import { VelavuPermission } from "velavu-js-api";

export interface UseOrganizePermissionsResult {
	/// Returns whether the user has a specific permission, or undefined
	/// if permissions are invalid
	hasPermission: (permission: VelavuPermission) => boolean | undefined;
}

export default function useOrganizePermissions(
	permissions: VelavuPermission[] | undefined,
): UseOrganizePermissionsResult {
	//Collect the permissions into a set
	const permissionSet = useMemo<
		ReadonlySet<VelavuPermission> | undefined
	>(() => {
		if (permissions === undefined) {
			return undefined;
		} else {
			return new Set(permissions);
		}
	}, [permissions]);

	const hasPermission = useCallback(
		(permission: VelavuPermission) => {
			if (permissionSet === undefined) {
				return false;
			} else {
				return permissionSet.has(permission);
			}
		},
		[permissionSet],
	);

	return {
		hasPermission,
	};
}
